import Util from './../../../libs/util'
const { ajax,globalModalContain } = Util
function http ({ url,type,params,fail,final }) {
    return new Promise((resolve,reject) => {
        ajax[type](url,params).then(
            res => {
                const { code, data,msg='' } = res.data || {}
                if(code===1) {
                    resolve(data)
                } else {
                    globalModalContain.$Modal.error({
                        title:'错误',
                        content: msg
                    })
                    reject(new Error(''))
                }
            }
        ).catch(() => {
            globalModalContain.$Modal.error({
                title:'错误',
                content: '网络错误'
            })
            if(fail) {
                fail()
            }
            reject(new Error('网络错误'))
        }).finally(() => {
            if(final) {
                final()
            }
        })
    })
}

// 获取app详情
export function getAppDetailApi (params,callBack) {
    return http({
          url: '/route_app/detail',
          type:'get',
          final:callBack,
          params:{ params }
    })
}

// 获取app列表
export function getAppRouterListApi (params,callBack) {
    return http({
        url: '/route_app/list',
        type:'get',
        final:callBack,
        params
  })
}
// 更新app数据
export function updateAppItemApi (params,callBack) {
    return http({
        url: '/route_app/update',
        type:'post',
        final:callBack,
        params
    })
}

// 新增/编辑路由信息
export function updateRouterApi (params,callBack) {
    return http({
        url: '/route_menu_item/update',
        type:'post',
        final:callBack,
        params
  })
}
// 获取权限详情

export function getJurisdictionDetailApi ( params,callBack) {
    return http({
        url: '/route_menu_item/auth_info',
        type:'get',
        final:callBack,
        params:{ params }
  })
}

// 获取group列表
export function getGroupListApi (params,callBack) {
    return http({
        url: '/route_group/all',
        type:'get',
        final:callBack,
        params:{ params }
  })
}

// 保存修改群组
export function editGroupJurisdictionApi (params,callBack) {
    return http({
        url: '/route_menu_item/edit_auth',
        type:'post',
        final:callBack,
        params
  })
}

// 获取人员列表
export function getGroupCustomersApi (params,callBack) {
    return http({
        url: '/route_group/customers',
        type:'get',
        fail:callBack,
        params:{ params }
  })
}
// 节点拖拽

export function dragNodeApi (params,callBack) {
    return http({
        url: '/route_menu_item/rearrange',
        type:'post',
        final:callBack,
        params
  })
}